import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { ChangeMerchTypeSuccess } from '@webapp/store/merch/action-creators';
import { CHANGE_MERCH_TYPE_SUCCESS } from '@webapp/store/merch/actions';
import AppState from '@webapp/store/state';

export const merchProductStarted = (
  action$: Observable<ChangeMerchTypeSuccess>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(CHANGE_MERCH_TYPE_SUCCESS),
    withLatestFrom(state$),
    map(() => {
      if (window.analytics) {
        window.analytics.track('Product Started', {
          created_by: 'User',
          category: 'Merch',
        });
      }
    }),
    filter(() => false)
  );
